import React from 'react';
import ClearShipPlayLogo from '@/images/ship-play-sticks-skis-logo.png';

const OurServiceSection = () => {
  return (
    <div className="bg-[#F8F9FB] text-center lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-16 w-full">
      <div className="flex flex-col gap-11 lg:flex-row justify-between items-center max-w-7xl mx-auto">
        <div className="lg:w-3/5">
          <p className="text-[20px] font-semibold text-[#1C2938] mb-5">
            Don’t want to haul stuff for the kids? Have items that can’t
            miss a connection? Just ship It and we’ll have you covered.
          </p>
          <p className="text-gray-600 text-lg mb-5">
            Ship&Play is the latest offering from the team behind Ship Sticks
            and Ship Skis. We have over a decade of experience shipping sports
            equipment worldwide, bringing the same white-glove service and
            dependability to shipping luggage.
          </p>
          <p className="text-gray-600 text-lg">
            We also believe in hassle-free travel days, so we’ve partnered with
            CLEAR to give CLEAR Plus Members 50% off their first shipment! Just
            enter your email address above and we’ll email you your discount code.
          </p>
        </div>
        <div className="
          sm:flex-shrink-0 flex flex-col items-center justify-center text-center space-y-2
        bg-white border border-gray-300 px-6 py-4 rounded-2xl
        ">
          <img
            src={ClearShipPlayLogo}
            alt="Ship&Play Logo"
            className="w-96 h-72 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default OurServiceSection;
